import { render } from "./House.vue?vue&type=template&id=0cb3e22c&scoped=true&ts=true"
import script from "./House.vue?vue&type=script&lang=ts"
export * from "./House.vue?vue&type=script&lang=ts"

import "./House.vue?vue&type=style&index=0&id=0cb3e22c&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb3e22c"]])

export default __exports__